export enum SafetyRiskAlertEvents {
  safetyRiskAlertViewed = 'Safety Risk Alert Viewed',
  safetyRiskAlertAcknowledged = 'Safety Risk Alert Acknowledged',
}

export enum SafetyRiskAlertEventAttribute {
  AlertId = 'alertId',
  TriggerReason = 'triggerReason',
  PatientId = 'patientId',
  SurveyResponseExternalId = 'surveyResponseExternalId',
}
